import { Collapse, ListItemIcon, MenuItem, Tooltip, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { MenuItemLink, DashboardMenuItem, useTheme, useResourceDefinitions, useSidebarState } from 'react-admin';
import SettingsIcon from '@mui/icons-material/Settings';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PaidIcon from '@mui/icons-material/Paid';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WindowIcon from '@mui/icons-material/Window';
import GroupIcon from '@mui/icons-material/Group';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShieldIcon from '@mui/icons-material/Shield';
import InfoIcon from '@mui/icons-material/Info';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const SubMenu = (props: any) => {
    const theme = useTheme();
    const [show, setShow] = useState(false);

    return <React.Fragment>
        <MenuItem dense={false} onClick={() => { setShow(!show) }}>
            {
                !props.open ?
                    <Tooltip title={props.title} placement="right">
                        <ListItemIcon style={{ minWidth: 40 }}>
                            {show ? <ExpandMoreIcon /> : props.leftIcon}
                        </ListItemIcon>
                    </Tooltip>
                    :
                    <ListItemIcon style={{ minWidth: 40 }}>
                        {show ? <ExpandMoreIcon /> : props.leftIcon}
                    </ListItemIcon>
            }
            <Typography color="textSecondary">
                {props.title}
            </Typography>
        </MenuItem>
        <Collapse in={show} timeout="auto" unmountOnExit>
            {props.children}
        </Collapse>
    </React.Fragment>
}

const Menu = ({ onMenuClick, logout }: any) => {

    const isXSmall = useMediaQuery((theme: any) => theme.breakpoints.down('xs'));
    // const open = useSelector((state: any) => state.admin.ui.sidebarOpen);
    const [open] = useSidebarState();
    // const resources = useSelector(getResources);
    const resourcesDefinitions = useResourceDefinitions();
    const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);

    const props = { onMenuClick, logout, open };

    const groups = [
        { name: '设置', icon: <SettingsIcon /> },
        { name: '会员', icon: <GroupIcon /> },
        { name: '产品', icon: <WindowIcon /> },
        { name: '订单', icon: <ShoppingCartIcon /> },
        { name: '供应', icon: <LocalShippingIcon /> },
        { name: '财务', icon: <PaidIcon /> },
        { name: '市场', icon: <ShieldIcon /> },
        { name: '信息', icon: <InfoIcon /> },
        { name: '其它', icon: <MoreHorizIcon /> },
    ]

    return (
        <div>
            <DashboardMenuItem
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            {groups.map((group, index) => {
                let resArr = resources.filter((t: any) => t.options.group == group.name);
                if (resArr.length > 0)
                    return (
                        <SubMenu key={index} {...props} title={group.name} leftIcon={group.icon}>
                            {resArr.map((resource: any) => (
                                <MenuItemLink
                                    key={resource.name}
                                    to={`/${resource.name}`}
                                    primaryText={resource.options && resource.options.label || resource.name}
                                    leftIcon={resource.options && resource.options.icon}
                                    onClick={onMenuClick}
                                    sidebarIsOpen={open}
                                    sx={{ pl: open ? 4 : 3 }}
                                />
                            ))}
                        </SubMenu>)
                else
                    return null;
            })}

            {/* <MenuItemLink
                to="/custom-route"
                primaryText="Miscellaneous"
                leftIcon={<LabelIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            /> */}
            {isXSmall && logout}
        </div>
    );
};

export default Menu;